import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { MESSAGES } from "../../../utlis/messages";

const GET_PROFILE = `auth/profileDetails`
const UPDATE_PROFILE = `auth/updateProfile`

export const GetProfileDetails = createAsyncThunk(
  "profileDetails",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${GET_PROFILE}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProfile = createAsyncThunk(
  "updateProfile",
  async ({ values }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(UPDATE_PROFILE, values);
      successMessage( MESSAGES.PROFILE_UPDATED)
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG);
      return rejectWithValue(error.response.data);
    }
  }
);